import { Avatar, Dropdown, message, Modal, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";
import doxzonLogo from "../Assets/logo/Doxzon_Logo_White_background.svg";
import {
  FaClipboardList,
  FaShoppingCart,
  FaUser,
  FaWpforms,
} from "react-icons/fa";
import hamburge from "../Assets/Images/hamburger.png";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { APP_ROUTES } from "../PageRouting/PageRoutes";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
import NotificationService from "../Services/NotificationService";
import { IoClose } from "react-icons/io5";
import Invoice from "../Assets/Icons/invoice.svg";
import Billing from "../Assets/Icons/billingNewIcon.svg"
import { useDispatch, useSelector } from "react-redux";
import { IoMdNotificationsOutline } from "react-icons/io";
import { CloudUploadOutlined } from "@ant-design/icons";
import PatientSearch from "./PatientSearch";
import { getCartDetails } from "../Redux/actions/cartActions";
import { encodeBase64File } from "../utils/encodeBase64";
import ConsultationService from "../Services/ConsultationService";
import { fetchPatientStethReports } from "../Redux/actions/patientActions";
import profileHover from "../Assets/Images/Svg/profileHover.svg";
import profileLogout from "../Assets/Images/Svg/profileLogout.svg";
import { useNavigation } from "../Context/NavigationContext";
import { RESET_STORE } from "../store";
import PrescriptionCartOrder from "../Components/Pages/OrderMedicine/prescriptionCartOrder";
dayjs.extend(utc);
dayjs.extend(timezone);

function Header({ handleSideBarMenu }) {
  const history = useHistory();
  const [logoutModal, setLogoutModal] = useState(false);
  const accountObj = sessionStorage.getItem("accountinfo");
  const accountData = accountObj ? JSON.parse(accountObj)[0] : null;
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
  const isSuperAdmin = loggedUser?.user?.rolecode === "SUPERADMIN";
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [notification, setNotification] = useState([]);
  const [count, setCount] = useState(0);
  const [showNotification, setShowNotification] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [saveLoader, setSaveLoader] = useState(false);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  const totalnotifyCount = useSelector((state) => state.notification.count);
  const { selectedPatient } = useSelector((state) => state.patients);
  const { cartData } = useSelector((state) => state.cart);
  const [enrollmentModalOpen, setEnrollmentModalOpen] = useState(false);
  const [selectedEnrollmentType, setSelectedEnrollmentType] =
    useState("doctor");
  const { navigate, isPending } = useNavigation();
  const [presCartMod, setPresCartMod] = useState(false);

  const doctorUrl = process.env.REACT_APP_DOCTOR_ENROLLMENT_URL;
  const rpmDoctorUrl = process.env.REACT_APP_RPM_DOCTOR_ENROLLMENT_URL;
  const doctorFormLink = `${doctorUrl}`;
  const rpmDoctorFormLink = `${rpmDoctorUrl}`;

  const copyToClipboard = async (text, label) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(`${label} copied successfully`);
    } catch (error) {
      message.error("Failed to copy link");
    }
  };

  const handleCopyEnrollmentLink = () => {
    const selectedLink =
      selectedEnrollmentType === "doctor" ? doctorFormLink : rpmDoctorFormLink;

    const label =
      selectedEnrollmentType === "doctor"
        ? "Doctor enrollment form link"
        : "RPM doctor enrollment form link";

    copyToClipboard(selectedLink, label);
  };

  useEffect(() => {
    if (loggedUser) fetchNotification();
  }, []);

  useEffect(() => {
    setCount(totalnotifyCount);
  }, [totalnotifyCount]);

  // useEffect(() => {
  //   if (loggedUser) notificationCount();
  // }, []);

  useEffect(() => {
    if (selectedPatient) {
      const payload = { patientId: selectedPatient.patientId };
      dispatch(getCartDetails(payload));
    }
  }, [selectedPatient]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setNotificationDropdown(false);
      }
    };

    if (notificationDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [notificationDropdown]);

 const toggleSideMenu = () => {
  setIsCollapsed((prev) => {
    const newState = !prev;
    handleSideBarMenu(!newState);
    return newState;
  });
};

  const handleLogout = () => {
    setLogoutModal(true);
  };

  const handleCancel = () => {
    setLogoutModal(false);
  };

  const handleOk = () => {
    sessionStorage.clear();
    sessionStorage.clear();
    dispatch({ type: RESET_STORE });
    setLogoutModal(false);
    setTimeout(() => {
      history.push(APP_ROUTES.LOGIN);
    }, 500);
  };

  const fetchNotification = async () => {
    try {
      let payload = {
        account_Id: loggedUser.user.account_Id,
        clinic_Id: loggedUser.user.clinic_Id,
        userId: loggedUser.user.userId,
        countStatus: "N",
        status: 1,
      };

      const response = await NotificationService.NotificationGet(payload);
      const notificationRes = response?.data?.[0];
      setNotification(notificationRes?.notificationList);
      setCount(notificationRes?.totalCount);
    } catch (error) {
      console.error("error");
    }
  };

  const notificationCount = async () => {
    let payload = {
      account_Id: loggedUser.user.account_Id,
      clinic_Id: loggedUser.user.clinic_Id,
      userId: loggedUser.user.userId,
      countStatus: "N",
      status: 1,
    };
    try {
      const response = await NotificationService.NotificationCountGet(payload);
      setCount(response.data.TOTAL_COUNT_STATUS);
      dispatch({ type: "COUNT", payload: response.data.TOTAL_COUNT_STATUS });
    } catch (error) {
      console.log("error data", error);
    }
  };

  const toggleNotificationDropdown = () => {
    setNotificationDropdown(!notificationDropdown);
  };

  const formatNotificationDate = (dateString) => {
    const now = dayjs();
    const notificationDate = dayjs.utc(dateString).local();

    if (notificationDate.isSame(now, "day")) {
      const diffInMinutes = now.diff(notificationDate, "minute");
      const diffInHours = now.diff(notificationDate, "hour");

      if (diffInHours > 0) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
      } else {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
      }
    } else {
      return notificationDate.format("DD/MM/YYYY HH:mm");
    }
  };

  const handleNotificationClick = async (notificationItem) => {
    if (notificationItem.countStatus === "N") {
      try {
        let Payload = {
          id: notificationItem.id,
          countStatus: "Y",
          modifiedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };

        await NotificationService.NotificationCountStatusPut(Payload);
        setNotification((prevNotifications) =>
          prevNotifications.map((item) =>
            item.id === notificationItem.id
              ? { ...item, countStatus: "Y" }
              : item,
          ),
        );
        dispatch({ type: "SEEN", payload: totalnotifyCount - 1 });
      } catch (error) {
        console.error("Error updating notification:", error);
      }
    }

    setShowNotification(
      showNotification === notificationItem.id ? null : notificationItem.id,
    );
  };

  const isToday = (date) => {
    return dayjs(date).isSame(dayjs(), "day");
  };

  function truncateString(str, num) {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  }

  const menuItems = [
    {
      key: "userInfo",
      label: (
        <div className="p-2 cursor-default">
          <p className="text-black text-sm mb-0">
            {`${loggedUser?.user.salutation} ${loggedUser?.user.firstName} ${loggedUser?.user.lastName}`}
          </p>
          <p className="text-black text-xs font-thin mb-0">
            {loggedUser?.user.email}
          </p>
        </div>
      ),
      disabled: true,
    },
    { type: "divider" },
    {
      key: "logout",
      label: (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a onClick={handleLogout} className="text-red-500 hover:text-red-700">
          Logout
        </a>
      ),
    },
  ];

  const handleInvoiceNavigation = () => {
    navigate(APP_ROUTES.INVOICE);
  };

  const handleBillingNavigation = () => {
    navigate(APP_ROUTES.BILLINGPAYMENTS);
  };

  const handleStethRepModal = () => {
    setUploadModalOpen(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (file.type !== "application/pdf") {
      message.error("Only PDF files allowed");
      return;
    }

    setSelectedFile(file);
  };

  const saveUploadedFile = async () => {
    if (!selectedFile) {
      message.error("Please upload a PDF file");
      return;
    }
    setSaveLoader(true);
    try {
      const base64File = await encodeBase64File(selectedFile);
      const payload = {
        consultationId: null,
        createdBy: loggedUser.user.userId,
        createdDate: new Date().toISOString().slice(0, 19).replace("T", " "),
        document: base64File,
        documentType: "pdf",
        modifiedBy: loggedUser.user.userId,
        modifiedDate: new Date().toISOString().slice(0, 19).replace("T", " "),
        ogDocumentName: selectedFile.name,
        ogDocumentType: "DIGITAL_STETHOSCOPE",
        patientId: selectedPatient?.patientId,
        status: 1,
        userId: selectedPatient?.createdBy,
        appointmentId: null,
      };

      let res = await ConsultationService.saveSteth(payload);

      if (res.status === 200) {
        message.success("File uploaded successfully!");
        setUploadModalOpen(false);
        setSelectedFile(null);
        dispatch(
          fetchPatientStethReports({
            patientId: selectedPatient?.patientId,
            status: 1,
          }),
        );
      }
    } catch (err) {
      console.error("Upload error:", err);
      message.error("Upload failed");
    } finally {
      setSaveLoader(false);
    }
  };

  const handlePresCartMod = () => {
    setPresCartMod(!presCartMod);
  };

  return (
    <>
      <div className="w-full flex justify-between items-center sticky top-0 z-[200] h-[70px] p-3 bg-[#F1FFF9]">
        <div className="flex items-center">
          <img
            className={`h-5 w-5 mt-2 cursor-pointer`}
            src={hamburge}
            alt="1"
            onClick={toggleSideMenu}
          />
          <img className="mt-2 ml-4 w-28" src={doxzonLogo} alt="icon" />
        </div>

        <div className="w-3/5 flex items-center justify-end gap-5  mx-2">
          {isSuperAdmin && (
            <Tooltip placement="bottom" title="Enrollment Form Link">
              <button
                onClick={() => setEnrollmentModalOpen(true)}
                className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer"
              >
                <FaWpforms className="text-brand-primaryColor text-xl" />
              </button>
            </Tooltip>
          )}
          <Tooltip placement="bottom" title="Billing">
            <button
              onClick={handleBillingNavigation}
              className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer"
            >
              <img src={Billing} alt="" className="w-7 h-7" />
            </button>
          </Tooltip>
          <Tooltip placement="bottom" title="Invoice">
            <button
              onClick={handleInvoiceNavigation}
              className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer"
            >
              <img src={Invoice} alt="" />
            </button>
          </Tooltip>

          <div className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer">
            <Tooltip placement="bottom" title="Stethescope report">
              <button
                disabled={!selectedPatient}
                className="disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handleStethRepModal}
              >
                <CloudUploadOutlined className="text-[#189FAA] text-lg" />
              </button>
            </Tooltip>
          </div>

          <div className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer">
            <Tooltip placement="bottom" title="Prescription Order">
              <button
                disabled={!selectedPatient}
                className="disabled:cursor-not-allowed disabled:opacity-50"
                onClick={handlePresCartMod}
              >
                <FaClipboardList className="text-[#189FAA] text-lg" />
              </button>
            </Tooltip>
          </div>

          <div className="relative" ref={dropdownRef}>
            <Tooltip placement="bottom" title="Notifications">
              <div
                className="w-10 h-10 rounded-full border-[#D0E2E1] border flex items-center justify-center cursor-pointer"
                onClick={toggleNotificationDropdown}
              >
                <IoMdNotificationsOutline className="w-6 h-6 text-[#189FAA]" />
              </div>
            </Tooltip>
            {count > 0 && (
              <span className="absolute top-1 right-2 bg-red-500 text-white text-[8px] px-1.5 py-[2px] rounded-full">
                {count > 99 ? "99+" : count}
              </span>
            )}
            {notificationDropdown && (
              <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div className="p-4">
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold">Notifications</h3>
                    <button
                      onClick={toggleNotificationDropdown}
                      className="text-gray-500 text-xl hover:text-gray-700"
                    >
                      <IoClose onClick={fetchNotification} />
                    </button>
                  </div>
                  <div className="max-h-72 overflow-y-auto scrollWidth">
                    {notification.length > 0 ? (
                      <>
                        {notification.slice(0, 10).map((item) => (
                          <div
                            key={item.id}
                            className={`p-4 rounded-md border mb-3 cursor-pointer transition-all duration-300
                           ${
                             item.countStatus === "N"
                               ? isToday(item.date)
                                 ? "bg-blue-100 border-blue-500 font-bold"
                                 : "bg-gray-100 border-gray-400"
                               : "bg-white"
                           }
                           `}
                            onClick={() => handleNotificationClick(item)}
                          >
                            <div className="text-sm font-medium">
                              {item.subject}
                            </div>
                            <div className="text-xs text-gray-400 flex justify-end">
                              {formatNotificationDate(item.date)}
                              {item.countStatus === "N" && (
                                <span
                                  className={`text-xs text-white px-1 py-0.5 rounded-md ml-1 ${
                                    isToday(item.date)
                                      ? "bg-green-500"
                                      : "bg-blue-400"
                                  }`}
                                >
                                  {isToday(item.date) ? "New" : "Unseen"}
                                </span>
                              )}
                            </div>

                            <div className="text-xs text-gray-500">
                              {item.countStatus === "Y" ||
                              showNotification === item.id
                                ? item.content
                                : truncateString(item.content, 30)}
                            </div>
                          </div>
                        ))}

                        {count > 10 && (
                          <div
                            onClick={toggleNotificationDropdown}
                            className="text-center p-2 border-t"
                          >
                            <button
                              onClick={() => navigate("/notification")}
                              className="text-blue-500 hover:underline"
                            >
                              See More
                            </button>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="text-center text-gray-500">
                        You have no new notifications at the moment
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="relative">
            <Tooltip placement="bottom" title="Cart">
              <button
                disabled={!selectedPatient}
                className="disabled:cursor-not-allowed disabled:opacity-50"
              >
                <FaShoppingCart
                  className="w-6 h-7 text-[#189FAA] cursor-pointer"
                  onClick={() => navigate(APP_ROUTES.MYCART)}
                />
              </button>
            </Tooltip>
            {selectedPatient && cartData?.cartItemsCount > 0 && (
              <span className="absolute -top-1.5 -right-2.5 bg-red-500 text-white text-[8px] px-1.5 py-[2px] rounded-full">
                {cartData?.cartItemsCount > 99
                  ? "99+"
                  : cartData?.cartItemsCount}
              </span>
            )}
          </div>
          {/* <Dropdown
            menu={{ items: menuItems }}
            trigger={["hover"]}
            placement="bottomRight"
          >
            <div className="w-10 h-10 rounded-full p-1 border-[#D0E2E1] border flex items-center justify-center cursor-pointer bg-white">
              {accountData?.logoName ? (
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}${accountData?.logoName}`}
                  className="w-full object-cover rounded-full"
                  alt="Logo"
                />
              ) : (
                <FaUser className="w-6 h-6" />
              )}
            </div>
          </Dropdown> */}
          <div className="hidden group relative md:block cursor-pointer paste-button z-[100]">
            {accountData?.logoName ? (
              <div className="w-10 h-10 rounded-full p-1 border-[#D0E2E1] border flex items-center justify-center cursor-pointer bg-white">
                <img
                  src={process.env.REACT_APP_IMAGE_URL + accountData?.logoName}
                  alt="User account Logo"
                  className="w-full object-cover rounded-full"
                />
              </div>
            ) : (
              <div className="rounded-full border border-brand-secondaryColor md:w-12 w-10 md:h-12 h-10 ml-6 flex justify-center items-center">
                <FaUser className="w-6 h-6" />
              </div>
            )}

            <div className="hidden group-hover:block z-10 absolute rounded-md  border-2 top-10 w-72 bg-white p-2 right-3">
              <div
                className="p-2 bg-cover flex flex-col gap-2 items-center justify-center rounded-md bg-center"
                style={{ backgroundImage: `url(${profileHover})` }}
              >
                {loggedUser && loggedUser?.user?.imageName ? (
                  <div className="rounded-full mt-2 md:w-12 w-24 md:h-12 h-24  flex justify-center items-center">
                    <img
                      src={
                        process.env.REACT_APP_IMAGE_URL +
                        loggedUser.user.imageName
                      }
                      alt="DocImg"
                      className="rounded-full md:w-12 w-6 md:h-12 h-6"
                    />
                  </div>
                ) : (
                  <div className="rounded-full border border-brand-secondaryColor md:w-12 w-10 md:h-12 h-10 ml-6 flex justify-center items-center">
                    <FaUser className="md:w-8 w-6 md:h-8 h-6" />
                  </div>
                )}
                <p className="text-white font-bold text-sm mb-0">
                  {`${loggedUser?.user.salutation} ${loggedUser?.user.firstName} ${loggedUser?.user.lastName}`}
                </p>
                <p className="text-white font-bold text-xs mb-0 ">
                  {loggedUser?.user.email}
                </p>
              </div>
              <span className="flex flex-col gap-2 mt-2 ">
                <span
                  className="flex gap-2 p-1 rounded-md hover:border hover:border-[#189FAA]"
                  onClick={handleLogout}
                >
                  <img src={profileLogout} alt="" /> <span>Logout</span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`w-full h-16 flex justify-between items-center sticky top-[70px] z-[100] py-0.5 px-3 bg-brand-White`}
      >
        <PatientSearch />
      </div>

      {/* Logout Confirmation */}
      <Modal
        title="Confirm Logout"
        width={"25%"}
        open={logoutModal}
        onCancel={handleCancel}
        footer={
          <div className="mt-6">
            <button
              className="mx-1 p-1 w-28 font-semibold text-brand-primaryColor border border-brand-primaryColor rounded-md"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="mx-1 p-1 w-28 font-semibold custom_filter text-brand-White rounded-md"
              onClick={handleOk}
            >
              Yes
            </button>
          </div>
        }
      >
        Are you sure you want to log out?
      </Modal>

      {/* Adding New stethscope report  */}
      <Modal
        open={uploadModalOpen}
        onCancel={() => setUploadModalOpen(false)}
        footer={[]}
        destroyOnClose
        title={
          <h2 className="text-lg font-semibold mb-4">
            Upload Stethescope report
          </h2>
        }
      >
        <div className="flex flex-col gap-4">
          {/* Upload UI */}
          <div className="flex flex-col">
            <label className="text-sm font-sans font-medium text-gray-700 mb-1">
              Upload Report (PDF Only)
            </label>

            <div
              className="border-2 border-dashed border-gray-300 rounded-md py-4 px-4 text-center cursor-pointer hover:border-[#189FAA]"
              onClick={() =>
                document.getElementById("upload-steth-file").click()
              }
            >
              <CloudUploadOutlined className="text-[#189FAA] text-lg mb-1" />
              <p className="text-xs text-gray-600 font-medium">
                Click to upload PDF
              </p>
            </div>

            <input
              id="upload-steth-file"
              type="file"
              className="hidden"
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </div>

          {/* Selected File Preview */}
          {selectedFile && (
            <div className="border rounded-md p-3 flex justify-between items-center bg-gray-50">
              <span className="text-sm font-medium">{selectedFile.name}</span>

              <button
                className="text-red-500 hover:text-red-600 text-xs"
                onClick={() => setSelectedFile(null)}
              >
                Remove
              </button>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex justify-end gap-3 mt-4">
            <button
              className="px-5 py-1.5 border border-brand-primaryColor text-brand-primaryColor rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => {
                setUploadModalOpen(false);
                setSelectedFile(null);
              }}
              disabled={saveLoader}
            >
              Cancel
            </button>

            <button
              className="px-5 py-1.5 bg-[#189FAA] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={saveUploadedFile}
              disabled={!selectedFile || saveLoader}
            >
              Upload
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        open={enrollmentModalOpen}
        onCancel={() => setEnrollmentModalOpen(false)}
        footer={null}
        title={
          <h2 className="text-lg font-semibold text-[#189FAA]">
            Enrollment Form Links
          </h2>
        }
        centered
      >
        <div className="flex flex-col gap-5 mt-5">
          {/* Doctor Form */}
          <div
            onClick={() => setSelectedEnrollmentType("doctor")}
            className={`border rounded-xl p-4 cursor-pointer transition-all duration-200 flex items-center justify-between
      ${
        selectedEnrollmentType === "doctor"
          ? "border-[#189FAA] bg-[#F1FFFD]"
          : "border-gray-200 hover:border-[#189FAA]"
      }`}
          >
            <div className="flex items-center gap-3">
              {/* Checkbox */}
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center
          ${
            selectedEnrollmentType === "doctor"
              ? "border-[#189FAA] bg-[#189FAA]"
              : "border-gray-300"
          }`}
              >
                {selectedEnrollmentType === "doctor" && (
                  <span className="text-white text-xs">✓</span>
                )}
              </div>

              <div>
                <p className="text-sm font-semibold mb-0">
                  Doctor Enrollment Form
                </p>
                <p className="text-xs text-gray-500 mb-0">
                  Copy doctor enrollment registration link
                </p>
              </div>
            </div>
          </div>

          {/* RPM Doctor Form */}
          <div
            onClick={() => setSelectedEnrollmentType("rpm")}
            className={`border rounded-xl p-4 cursor-pointer transition-all duration-200 flex items-center justify-between
      ${
        selectedEnrollmentType === "rpm"
          ? "border-[#189FAA] bg-[#F1FFFD]"
          : "border-gray-200 hover:border-[#189FAA]"
      }`}
          >
            <div className="flex items-center gap-3">
              {/* Checkbox */}
              <div
                className={`w-5 h-5 rounded border-2 flex items-center justify-center
          ${
            selectedEnrollmentType === "rpm"
              ? "border-[#189FAA] bg-[#189FAA]"
              : "border-gray-300"
          }`}
              >
                {selectedEnrollmentType === "rpm" && (
                  <span className="text-white text-xs">✓</span>
                )}
              </div>

              <div>
                <p className="text-sm font-semibold mb-0">
                  RPM Doctor Enrollment Form
                </p>
                <p className="text-xs text-gray-500 mb-0">
                  Copy RPM doctor enrollment registration link
                </p>
              </div>
            </div>
          </div>

          {/* Copy Button */}
          <button
            onClick={handleCopyEnrollmentLink}
            className="w-full mt-2 bg-[#189FAA] hover:bg-[#147d86] text-white py-2.5 rounded-lg font-medium transition-all duration-200"
          >
            Copy Form Link
          </button>
        </div>
      </Modal>

      {/* Adding prescription medicines to cart */}
      <Modal
        open={presCartMod}
        onCancel={handlePresCartMod}
        footer={[]}
        width={"50%"}
        destroyOnClose
      >
        <PrescriptionCartOrder
          handleClosePrescOrdMod={handlePresCartMod}
          selectedPatient={selectedPatient}
        />
      </Modal>
    </>
  );
}

export default Header;
